module.exports = __webpack_public_path__ + "img/platform.0d51a9a8.svg";